import styled from 'styled-components';
import { min } from '../../../../theme/breakpoints';

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and ${min('tablet')} {
    flex-direction: row;
  }
  a + a {
    margin-top: 1rem;

    @media screen and ${min('tablet')} {
      margin-top: 0rem;
      margin-left: 1rem;
    }
  }
  a.outlined {
    color: ${({ theme }) => theme.colors.White};
    border-color: ${({ theme }) => theme.colors.White};
  }
`;
